import { AnimationEvent } from '@angular/animations';
import { Component, EventEmitter, Inject, Injector } from '@angular/core';

import { FADEIN_FADEOUT, SLIDE_LEFT_RIGHT, SLIDE_UP_DOWN } from '../fullscreen-modal-animations';
import { FullscreenModalConfig } from '../fullscreen-modal-config';
import { FullscreenModalRef } from '../fullscreen-modal-ref';
import { FULLSCREEN_DIALOG_DATA, FULLSCREEN_MODAL_CONFIG, FULLSCREEN_MODAL_REF } from '../fullscreen-modal-tokens';

@Component({
  selector: 'app-fullscreen-container-modal',
  templateUrl: './fullscreen-container-modal.component.html',
  styleUrls: ['./fullscreen-container-modal.component.scss'],
  animations: [SLIDE_LEFT_RIGHT, SLIDE_UP_DOWN, FADEIN_FADEOUT]
})
export class FullscreenContainerModalComponent {
  state: 'void' | 'enter' | 'leave' = 'enter';
  fadeState: 'void' | 'enter' | 'leave' = 'void';
  animationStateChanged = new EventEmitter<AnimationEvent>();
  dataInjector: Injector;
  showContent: boolean = false;

  constructor(
    @Inject(FULLSCREEN_MODAL_REF) public component: any,
    public dialogRef: FullscreenModalRef,
    @Inject(FULLSCREEN_MODAL_CONFIG) public config: FullscreenModalConfig,
    injector: Injector
  ) {
    this.dataInjector = Injector.create({
      providers: [{ provide: FULLSCREEN_DIALOG_DATA, deps: [], useValue: config.data }],
      parent: injector
    });
  }

  onAnimationStart(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  onAnimationDone(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
    this.showContent = true;
    this.fadeState = 'enter';
  }

  startExitAnimation() {
    this.state = 'leave';
    this.fadeState = 'leave';
  }
}
